import React from "react";

const steps = [
  {
    title: "Factory Quality Control",
    place: "Shenzhen Manufacturing Plant, China",
    start: "Feb 22, 2024",
    end: "Feb 24, 2024",
    duration: "2 days",
  },
  {
    title: "Distribution Warehouse",
    place: "Shanghai Central Warehouse, China",
    start: "Feb 25, 2024",
    end: "Mar 8, 2024",
    duration: "12 days",
  },
  {
    title: "International Shipping",
    place: "Sea Freight to Mumbai Port, India",
    start: "Mar 9, 2024",
    end: "Mar 16, 2024",
    duration: "8 days",
  },
  {
    title: "Regional Distributor",
    place: "Delhi Distribution Hub, India",
    start: "Mar 17, 2024",
    end: "Mar 21, 2024",
    duration: "5 days",
  },
  {
    title: "Retail Store",
    place: "TechMart Electronics, Mumbai, India",
    start: "—",
    end: "—",
    duration: "",
  },
];

const JourneyTimeline = ({ journeyTimelineData }) => {
  /** Inline styles */
  const styles = {
    container: {
      position: "relative",
      border: "1px solid #e1e8f7",
      borderRadius: 12,
      padding: 24,
      background: "#fff",
      boxShadow: "0 2px 8px rgba(16, 24, 40, 0.04)",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
      color: "#0f172a",
    },
    headerRow: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginBottom: 16,
    },
    headerIcon: {
      width: 20,
      height: 20,
      borderRadius: 6,
      background: "#e9f3ff",
      border: "1px solid #cfe3ff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1e66ff",
      fontWeight: 700,
      fontSize: 12,
    },
    headerTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: "#0f172a",
    },
    timelineWrap: {
      position: "relative",
      paddingLeft: 32,
    },
    itemRow: {
      position: "relative",
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
      marginBottom: 16,
    },
    dot: {
      position: "absolute",
      left: -20,
      top: 18,
      width: 12,
      height: 12,
      background: "#2f6bff",
      border: "3px solid #eaf2ff",
      borderRadius: "50%",
      boxShadow: "0 0 0 2px #dbe7ff",
      zIndex: 2,
    },
    card: {
      flex: 1,
      background: "#f6f9ff",
      border: "1px solid #dfe9ff",
      borderRadius: 10,
      padding: "16px 18px",
      boxShadow: "0 2px 6px rgba(30, 102, 255, 0.08)",
    },
    title: {
      fontSize: 14,
      fontWeight: 600,
      color: "#0f172a",
      marginBottom: 6,
    },
    subtitle: {
      fontSize: 13,
      color: "#42526e",
      marginBottom: 10,
    },
    metaRow: {
      display: "flex",
      alignItems: "center",
      gap: 18,
      fontSize: 12.5,
      color: "#334155",
    },
    metaItem: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
    },
    metaIconBox: {
      width: 18,
      height: 18,
      borderRadius: 4,
      background: "#fff",
      border: "1px solid #e5edff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#1e66ff",
      fontSize: 12,
    },
    divider: {
      height: 1,
      background: "#e5edff",
      margin: "12px 0 0 0",
    },
  };

  const CalendarIcon = () => <span style={styles.metaIconBox}>📅</span>;
  const ClockIcon = () => <span style={styles.metaIconBox}>⏱️</span>;

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerRow}>
        {/* <span style={styles.headerIcon}>⎈</span> */}
        {/* <span style={styles.headerTitle}>Journey Timeline</span> */}
      </div>

      {/* Timeline */}
      <div style={styles.timelineWrap}>

        {journeyTimelineData.map((it, idx) => {
          const isLastItem = idx === journeyTimelineData.length - 1;

          return (
            <div key={idx} style={styles.itemRow}>

              {!isLastItem && (
                <div
                  style={{
                    position: "absolute",
                    left: -15,
                    top: 24,
                    bottom: -24,
                    width: 4,
                    background: "linear-gradient(180deg, #dbe7ff 0%, #bfd5ff 100%)",
                    borderRadius: 4,
                    zIndex: 1,
                  }}
                />
              )}

              <div style={styles.dot} />

              {/* Card */}
              <div style={styles.card}>
                <div style={styles.title}>{it.fromEntity} → {it.toEntity}</div>
                <div style={styles.subtitle}>{it.locationTo}</div>

                <div style={styles.metaRow}>
                  <span style={styles.metaItem}>
                    <CalendarIcon />
                    {it.start !== "—" && it.end !== "—"
                      ? `${it.date}`
                      : "Date TBD"}
                  </span>
                  {it.duration && (
                    <span style={styles.metaItem}>
                      <ClockIcon />
                      {it.duration}
                    </span>
                  )}
                </div>
                <div style={styles.divider} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JourneyTimeline;